import { prefixHolder } from 'services/prefix-holder';
const { Gateway, WebFrontend } = prefixHolder;

export const oidcConfiguration = {
  authority: `${Gateway}`,
  client_id: 'safelyq.web',
  redirect_uri: `${WebFrontend}/authentication/callback`,
  // silent_redirect_uri: `${WebFrontend}/assets/silent-callback.html`, // loads IS4 in a hidden iframe, but obselete
  post_logout_redirect_uri: `${WebFrontend}/`,
  response_type: 'code',
  scope: 'openid profile email offline_access', // offline_access is required to get refresh token from IS4 server
  automaticSilentRenew: true,
  loadUserInfo: true,
};